<img alt="User picture" *ngIf="avatarImage; else noImageFound" class="avatar" [src]="avatarImage" />
<ng-template #noImageFound>
  <div *ngIf="userInitials" class="user-initials">
    {{ userInitials }}
  </div>
</ng-template>
